if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      this.modalContent.innerHTML = '';

      if (preventFocus) this.openedBy = null;
      super.hide();
    }

    show(opener) {
      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');
      opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      fetch(opener.getAttribute('data-product-url'))
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
          this.preventDuplicatedIDs();
          this.removeDOMElements();
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          if (window.ProductModel) window.ProductModel.loadShopifyXR();

          this.removeGalleryListSemantic();
          this.preventVariantURLSwitching();
          super.show(opener);
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;

      // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }

    preventVariantURLSwitching() {
      this.modalContent.querySelector('variant-radios,variant-selects').setAttribute('data-update-url', 'false');
      
      if($('.lineItem').length){
  $(document).on('click', '.product__info-container .variant_click', function(){
  var variantValue = $(this).data('value');
  // console.log(variantValue);
  if (variantValue == 'personalisieren') {
  $('.lineItem').addClass('active');
  $('p.line-item-property__field.font_main_input input#merriweather').prop('checked',true);
  }else{
  $('.lineItem').removeClass('active');
  $('p.line-item-property__field.font_main_input input').prop('checked',false);
  $('.lineItem input[type="text"]').val(' ');
  }
  });
  
  
  $('.lineItem input#firsttext').change(function () {
    var fstVal = $('.lineItem input#firsttext').val();
      var sndVal = $('.lineItem input#secondtext').val();
      if(fstVal > 0 || sndVal > 0){
         $('.errorfirst').css('display','none');
        $('.errorsecond').css('display','none');
      }
  })
  $('.lineItem input#secondtext').change(function () {
    var firstVal = $('.lineItem input#firsttext').val();
    var secondVal = $('.lineItem input#secondtext').val();
      if(firstVal > 0 || secondVal > 0){
        $('.errorfirst').css('display','none');
        $('.errorsecond').css('display','none');
      }
  })
  
  $('.check_submit').click(function() {
  var checkVal = $('.product-form__input input[type=radio]:checked+label').data('value');
  if(checkVal == 'personalisieren'){
  var textFirstVal = $('.lineItem input#firsttext').val();
  var textSecondVal = $('.lineItem input#secondtext').val();
  
  if(textFirstVal.length == 0){
    $('.errorfirst').css('display','block');
  }else{
    $('.errorfirst').css('display','none');
  }
  
  if(textSecondVal.length == 0){
    $('.errorsecond').css('display','block');
  }else{
    $('.errorsecond').css('display','none');
  }
    
  if(textFirstVal.length > 0 || textSecondVal.length > 0){
    if($(this).hasClass('cart__submit')){
    $('.product-form__submit').trigger('click');
      }else{
    $('.shopify-payment-button__button').trigger('click');
      }
  }
    
    }else{
    
    if($(this).hasClass('cart__submit')){
  $('p.line-item-property__field.font_main_input input').prop('checked',false);
    $('.product-form__submit').trigger('click');
      }else{
    $('.shopify-payment-button__button').trigger('click');
      }
    
    }
  })
  }
  }

    removeDOMElements() {
      const pickupAvailability = this.productElement.querySelector('pickup-availability');
      if (pickupAvailability) pickupAvailability.remove();

      const productModal = this.productElement.querySelector('product-modal');
      if (productModal) productModal.remove();
    }

    preventDuplicatedIDs() {
      const sectionId = this.productElement.dataset.section;
      this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
      this.productElement.querySelectorAll('variant-selects, variant-radios').forEach((variantSelect) => {
        variantSelect.dataset.originalSection = sectionId;
      });
    }

    removeGalleryListSemantic() {
      const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
      if (!galleryList) return;

      galleryList.setAttribute('role', 'presentation');
      galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
    }
  });
}


